window.submitLastSearchForm = submitLastSearchForm;
export function submitLastSearchForm(localStorageKey = 'last_search_form') {
    const data = JSON.parse(window.localStorage.getItem(localStorageKey));
    const form = document.createElement('form');
    form.method = data.form.method;
    form.action = data.form.action;

    Array.from(data.elements)
        .forEach((it) => form.innerHTML += `<input type="text" name="${it.name}" value="${it.value}" />`);

    // noinspection JSCheckFunctionSignatures
    document.body.appendChild(form);
    form.submit();
}

export function submitSearchFormHandler(noResults = false, event = {}, localStorageKey = 'last_search_form', cb = () => {}) {
    if(event.preventDefault) event.preventDefault();
    if(!event.target || !event.target.form) return;
    const form = event.target.form;

    if(noResults) {
        document.querySelector('input[name="Search[no_results]"]').value = 1;
        form.submit();
        return true;
    }

    const formEls = form.elements;
    const data = {
        form: {
            action: form.action,
            method: form.method,
        },
        elements: Array.from(formEls)
            .filter(item => item.name)
            .map(item => ({ name: item.name, value: item.value }))
    };

    window.localStorage.setItem(localStorageKey, JSON.stringify(data));

    if(cb) cb();

    form.submit();
    return true;
}
